export const IsNotInitialized = (enumValueAsString: string) =>
  !enumValueAsString || enumValueAsString === 'NotInitialized'

export const NotInitializedAsEmptyString = (enumValueAsString: string) =>
  IsNotInitialized(enumValueAsString) ? '' : enumValueAsString
